export * from "./apiShared";
import { ApiError } from "./apiShared";
export async function request<T>(path: string, body?: unknown): Promise<T> {
  const response = await fetch(`/api/housekeeping${path}`, {
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    ...(body ? { method: "POST", body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new ApiError(
      response.status,
      data.message || `Request failed (${response.status}). Please retry.`,
    );
  }
  return response.json();
}
